{
  "version": 1,
  "asset_id": "2aa6b3ab-a719-49b0-b3c4-31db4b21ea7d",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/2aa6b3ab-a719-49b0-b3c4-31db4b21ea7d/hiatal-type-iv-patient-before-es-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/2aa6b3ab-a719-49b0-b3c4-31db4b21ea7d/hiatal-type-iv-patient-before-es-1200.webp",
  "original_filename": "hiatal-type-iv-patient-before-es-1200.webp",
  "size": 99492,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:55:55Z"
}
